//import { Spinner } from 'spin.js';
import Spinner from 'spin.js';
window.Spinner = Spinner;
import * as Ladda from 'ladda';
window.Ladda = Ladda;
